// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__29N09","tab":"Tabs_tab__1qq1Q","tabActive":"Tabs_tabActive__2vGoS"};